module.exports = __webpack_public_path__ + "img/tip3.f3e22259.png";